var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseStudyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "white",
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.4216V43.0883M32 21.4216C30.0533 20.1283 27.41 19.3333 24.5 19.3333C21.59 19.3333 18.9467 20.1283 17 21.4216V43.0883C18.9467 41.7949 21.59 40.9999 24.5 40.9999C27.41 40.9999 30.0533 41.7949 32 43.0883M32 21.4216C33.9467 20.1283 36.59 19.3333 39.5 19.3333C42.4117 19.3333 45.0533 20.1283 47 21.4216V43.0883C45.0533 41.7949 42.4117 40.9999 39.5 40.9999C36.59 40.9999 33.9467 41.7949 32 43.0883",
    stroke: "url(#paint0_linear_9417_7855)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9417_7855",
    x1: 32,
    y1: 19.3333,
    x2: 32,
    y2: 43.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F86BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudyButton);
export default __webpack_public_path__ + "static/media/case-study-button.3a08e55cbef317b1d23b8e7bf2a84382.svg";
export { ForwardRef as ReactComponent };